import PropTypes from "prop-types";
import "./index.scss";

function PageContainer({
  as: Component = "div",
  children,
  className = "",
  size = "default",
}) {
  const classes = [
    "page-container",
    `page-container--${size}`,
    className,
  ].filter(Boolean).join(" ");

  return <Component className={classes}>{children}</Component>;
}

PageContainer.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(["default", "reading", "form", "wide", "full"]),
};

export { PageContainer };
